export default __webpack_public_path__ + "static/media/score-hero-badge.a6932314.png";